import {
  BatchNrcMarcContentRegConditionListItem,
  BatchNrcMarcContentRegConditionListItemFromJSON
} from '@/api/models/batch/BatchNrcMarcContentRegConditionListItem'

export interface BatchNrcMarcContentRegPageLoadResult {
  items: BatchNrcMarcContentRegConditionListItem
}

export function BatchNrcMarcContentRegPageLoadResultFromJSON(
  json: any
): BatchNrcMarcContentRegPageLoadResult {
  return {
    items: BatchNrcMarcContentRegConditionListItemFromJSON(json)
  }
}
